// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"146210bb","299":"0417ab01","453":"12e84b64","478":"a9019888"}[chunkId] + ".chunk.js";
};